<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">CONFIGURAÇÕES</li>
                </ol>

                <div class="row">
                    <div class="col-md-12" v-if="dados">

                        <form class="form-horizontal" >

                            <div class="panel panel-info">
                                <div class="panel-heading">RELATÓRIO DE BANDA</div>
                                <div class="panel-body" >
                                    <div class="form-group">
                                        <div class="col-sm-6">
                                            <label for="link_total" class="control-label">TOTAL DE BANDA CONTRATADA (MB):</label>
                                            <input id="link_total" disabled :value="dados.link_total.toFixed(2)" class="form-control text-right" >
                                        </div>
                                        <div class="col-sm-6">
                                            <label for="sum" class="control-label">TOTAL DE DOWNLOADS CONTRATADOS (MB):</label>
                                            <input id="sum" disabled :value="dados.sum.toFixed(2)" class="form-control text-right" >
                                        </div>
                                    </div>

                                    <h2 :class="{'text-info': media < 10, 'text-danger': media >= 10 }">
                                        <b>1</b> MB para cada <b>{{ media.toFixed(2) }}</b> Clientes.
                                    </h2>
                                </div>
                            </div>

                        </form>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { Contratos } from "../../class/index";

export default {
    data() {
        return {
            dados: null
        };
    },
    computed: {
        media() {
            return this.dados.sum / this.dados.link_total;
        }
    },
    beforeMount() {
        Contratos.getBanda()
            .then(data => (this.dados = data))
            .catch(err => console.log(err));
    }
};
</script>
